'use strict';

import {gsap} from 'gsap';

const $ = jQuery.noConflict();

$(function() {

	const ourClients = {

		init: function() {
			this.cacheDOM();
			if (!this.$rows.length) {
				return;
			}
			if (this.prefersReducedMotion) {
				return;
			}
			this.buildMarquees();
		},

		cacheDOM: function() {
			this.$rows = $('.js-our-clients-row');
			this.duration = 180;
			this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		},

		buildMarquees: function() {
			this.$rows.each((_, row) => {
				const track = row.querySelector('.js-our-clients-track');
				const set = track.querySelector('.js-our-clients-set');
				if (!track || !set) {
					return;
				}

				const direction = row.dataset.direction === 'rtl' ? 'rtl' : 'ltr';
				const viewportWidth = row.offsetWidth;
				const setWidth = set.offsetWidth;
				if (!setWidth) {
					return;
				}

				const minTrackWidth = viewportWidth * 2 + setWidth;
				let currentWidth = setWidth;
				while (currentWidth < minTrackWidth) {
					track.append(set.cloneNode(true));
					currentWidth += setWidth;
				}

				const distance = setWidth;
				const startX = direction === 'rtl' ? 0 : -distance;
				const endX = direction === 'rtl' ? -distance : 0;

				gsap.fromTo(track,
					{x: startX},
					{
						x: endX,
						repeat: -1,
						duration: this.duration,
						ease: 'linear',
					}
				);
			});
		},

	};

	ourClients.init();

});
